module.exports = __webpack_public_path__ + "static/img/6.d167cdb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news26/6.jpg
// module id = ux33
// module chunks = 1